import React from 'react';
import StaticPage from '../PageBuilder/StaticPage';
import { useIntl } from 'react-intl';
import { useConfiguration } from '../../context/configurationContext';
import { H2, LayoutSingleColumn, PrimaryButton, PrivacyPolicyContent } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterComponent from '../FooterContainer/FooterContainer';
import { useHistory } from 'react-router-dom';

import css from './PrivacyPolicyPage.module.css';

const PrivacyPolicyPage = () => {
  const intl = useIntl();
  const config = useConfiguration();

  const history = useHistory();

  const title = intl.formatMessage(
    { id: 'PrivacyPolicyPage.title' },
    { marketplaceName: config.marketplaceName }
  );

  return (
    <StaticPage
      title={title}
      openGraphType="website"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: title,
      }}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer currentPage="PrivacyPolicyPage" />}
        footer={<FooterComponent />}
      >
        <div className={css.container}>
          <H2 as="h1">{title}</H2>

          <PrivacyPolicyContent className={css.content} />

          <PrimaryButton type="button" onClick={() => history.goBack()}>
            {intl.formatMessage({ id: 'General.goBack' })}
          </PrimaryButton>
        </div>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default PrivacyPolicyPage;
